import React from 'react';
import PropTypes from "prop-types"
import {Link} from "react-router-dom";


const Btn2 = (props) => {
    return (
        <React.Fragment>
            <Link to={props.linkage} className="btn btn-dark btn-hover-primary">{props.name}</Link>
        </React.Fragment>
    )
}

Btn2.propTypes = {
    name: PropTypes.string,
    linkage:PropTypes.string
}

export default Btn2
